@if (product?.data) {
<div class="w-12">
    <!-- label -->
    @if (showLabel) {
    <div class="float-right no-wrap m-l p-t-1 p-r-2 p-b-1 p-l-2 p1"
         [ngStyle]="product.labelStyle || ''">{{product.label | translate}}</div>
    }
    <!-- product name -->
    <h1 class="h2">{{parent?.name || product.name}}</h1>
</div>
<!-- product sku -->
@if (product.data.sku && !product.isSoldOut) {
<p class="m-t-2">
    <span class="m-r-1">{{'Product Code' | translate}}:</span>
    {{product.data.sku}}
</p>
}
}
